import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('CONTACT_ORGANIZATION')